/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../model';
// @ts-ignore
import { GetCheckLocationNumberResponse } from '../model';
// @ts-ignore
import { GetLocationControllersResponse } from '../model';
// @ts-ignore
import { GetLocationDatabaseDetailRequest } from '../model';
// @ts-ignore
import { GetLocationResponse } from '../model';
// @ts-ignore
import { GetLocationUnitsResponse } from '../model';
// @ts-ignore
import { GetLocationsPagingResponse } from '../model';
// @ts-ignore
import { GetLocationsResponse } from '../model';
// @ts-ignore
import { GetTotalDataResponse } from '../model';
// @ts-ignore
import { PostLocationRequest } from '../model';
// @ts-ignore
import { PostLocationsResponse } from '../model';
// @ts-ignore
import { PutLocationRequest } from '../model';
// @ts-ignore
import { PutLocationsResponse } from '../model';
/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostLocationRequest} postLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExist: async (postLocationRequest: PostLocationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postLocationRequest' is not null or undefined
            assertParamExists('checkExist', 'postLocationRequest', postLocationRequest)
            const localVarPath = `/api/locations/check/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loationNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLocationByLocationNumber: async (loationNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loationNumber' is not null or undefined
            assertParamExists('checkLocationByLocationNumber', 'loationNumber', loationNumber)
            const localVarPath = `/api/locations/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (loationNumber !== undefined) {
                localVarQueryParameter['loationNumber'] = loationNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableLocation: async (id: string, reActive: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disableLocation', 'id', id)
            let localVarPath = "";
            if (reActive){
                localVarPath = `/api/locations/{id}/disconnect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            } else{
                localVarPath = `/api/locations/{id}/disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            }
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutLocationRequest} putLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLocation: async (id: string, putLocationRequest: PutLocationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editLocation', 'id', id)
            // verify required parameter 'putLocationRequest' is not null or undefined
            assertParamExists('editLocation', 'putLocationRequest', putLocationRequest)
            const localVarPath = `/api/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableLocation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableLocation', 'id', id)
            const localVarPath = `/api/locations/{id}/enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLocations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/locations/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControllersByLocationId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getControllersByLocationId', 'id', id)
            const localVarPath = `/api/locations/{id}/controllers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetLocationDatabaseDetailRequest} getLocationDatabaseDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailLocationDatabase: async (getLocationDatabaseDetailRequest: GetLocationDatabaseDetailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLocationDatabaseDetailRequest' is not null or undefined
            assertParamExists('getDetailLocationDatabase', 'getLocationDatabaseDetailRequest', getLocationDatabaseDetailRequest)
            const localVarPath = `/api/locations/detail-location-database`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLocationDatabaseDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocationById', 'id', id)
            const localVarPath = `/api/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsActiveWithCustomer: async (customerId: string, status: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getLocationsActiveWithCustomer', 'customerId', customerId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getLocationsActiveWithCustomer', 'status', status)
            const localVarPath = `/api/locations/customers/{customerId}/active`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {string} keySearch 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsPaging: async (limit: number, keySearch: string, page: number, orderBy: string, orderDesc: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getLocationsPaging', 'limit', limit)
            // verify required parameter 'keySearch' is not null or undefined
            assertParamExists('getLocationsPaging', 'keySearch', keySearch)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getLocationsPaging', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getLocationsPaging', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('getLocationsPaging', 'orderDesc', orderDesc)
            const localVarPath = `/api/locations/paging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (keySearch !== undefined) {
                localVarQueryParameter['keySearch'] = keySearch;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsWithCustomer: async (customerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getLocationsWithCustomer', 'customerId', customerId)
            const localVarPath = `/api/locations/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalLocation: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/locations/get-total-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitsByLocationId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUnitsByLocationId', 'id', id)
            const localVarPath = `/api/locations/{id}/units`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostLocationRequest} postLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCreateLocation: async (postLocationRequest: PostLocationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postLocationRequest' is not null or undefined
            assertParamExists('postCreateLocation', 'postLocationRequest', postLocationRequest)
            const localVarPath = `/api/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchActiveLocations: async (keySearch: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keySearch' is not null or undefined
            assertParamExists('searchActiveLocations', 'keySearch', keySearch)
            const localVarPath = `/api/locations/active/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keySearch !== undefined) {
                localVarQueryParameter['keySearch'] = keySearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostLocationRequest} postLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkExist(postLocationRequest: PostLocationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkExist(postLocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} loationNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkLocationByLocationNumber(loationNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCheckLocationNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkLocationByLocationNumber(loationNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableLocation(id: string, reActive:boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableLocation(id, reActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutLocationRequest} putLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editLocation(id: string, putLocationRequest: PutLocationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editLocation(id, putLocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableLocation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableLocation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveLocations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveLocations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControllersByLocationId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationControllersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControllersByLocationId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetLocationDatabaseDetailRequest} getLocationDatabaseDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailLocationDatabase(getLocationDatabaseDetailRequest: GetLocationDatabaseDetailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailLocationDatabase(getLocationDatabaseDetailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsActiveWithCustomer(customerId: string, status: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsActiveWithCustomer(customerId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} limit 
         * @param {string} keySearch 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsPaging(limit: number, keySearch: string, page: number, orderBy: string, orderDesc: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsPagingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsPaging(limit, keySearch, page, orderBy, orderDesc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsWithCustomer(customerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsWithCustomer(customerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalLocation(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTotalDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalLocation(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnitsByLocationId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnitsByLocationId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostLocationRequest} postLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCreateLocation(postLocationRequest: PostLocationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCreateLocation(postLocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchActiveLocations(keySearch: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchActiveLocations(keySearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @param {PostLocationRequest} postLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExist(postLocationRequest: PostLocationRequest, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.checkExist(postLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loationNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLocationByLocationNumber(loationNumber: string, options?: any): AxiosPromise<GetCheckLocationNumberResponse> {
            return localVarFp.checkLocationByLocationNumber(loationNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableLocation(id: string, options?: any): AxiosPromise<PutLocationsResponse> {
            return localVarFp.disableLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutLocationRequest} putLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editLocation(id: string, putLocationRequest: PutLocationRequest, options?: any): AxiosPromise<PutLocationsResponse> {
            return localVarFp.editLocation(id, putLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableLocation(id: string, options?: any): AxiosPromise<PutLocationsResponse> {
            return localVarFp.enableLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLocations(options?: any): AxiosPromise<GetLocationsResponse> {
            return localVarFp.getActiveLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControllersByLocationId(id: string, options?: any): AxiosPromise<GetLocationControllersResponse> {
            return localVarFp.getControllersByLocationId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetLocationDatabaseDetailRequest} getLocationDatabaseDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailLocationDatabase(getLocationDatabaseDetailRequest: GetLocationDatabaseDetailRequest, options?: any): AxiosPromise<GetLocationsResponse> {
            return localVarFp.getDetailLocationDatabase(getLocationDatabaseDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById(id: string, options?: any): AxiosPromise<GetLocationResponse> {
            return localVarFp.getLocationById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(options?: any): AxiosPromise<GetLocationsResponse> {
            return localVarFp.getLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsActiveWithCustomer(customerId: string, status: string, options?: any): AxiosPromise<GetLocationsResponse> {
            return localVarFp.getLocationsActiveWithCustomer(customerId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {string} keySearch 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsPaging(limit: number, keySearch: string, page: number, orderBy: string, orderDesc: string, options?: any): AxiosPromise<GetLocationsPagingResponse> {
            return localVarFp.getLocationsPaging(limit, keySearch, page, orderBy, orderDesc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsWithCustomer(customerId: string, options?: any): AxiosPromise<GetLocationsResponse> {
            return localVarFp.getLocationsWithCustomer(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalLocation(options?: any): AxiosPromise<GetTotalDataResponse> {
            return localVarFp.getTotalLocation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitsByLocationId(id: string, options?: any): AxiosPromise<GetLocationUnitsResponse> {
            return localVarFp.getUnitsByLocationId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostLocationRequest} postLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCreateLocation(postLocationRequest: PostLocationRequest, options?: any): AxiosPromise<PostLocationsResponse> {
            return localVarFp.postCreateLocation(postLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keySearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchActiveLocations(keySearch: string, options?: any): AxiosPromise<GetLocationsResponse> {
            return localVarFp.searchActiveLocations(keySearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkExist operation in LocationsApi.
 * @export
 * @interface LocationsApiCheckExistRequest
 */
export interface LocationsApiCheckExistRequest {
    /**
     * 
     * @type {PostLocationRequest}
     * @memberof LocationsApiCheckExist
     */
    readonly postLocationRequest: PostLocationRequest
}

/**
 * Request parameters for checkLocationByLocationNumber operation in LocationsApi.
 * @export
 * @interface LocationsApiCheckLocationByLocationNumberRequest
 */
export interface LocationsApiCheckLocationByLocationNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiCheckLocationByLocationNumber
     */
    readonly loationNumber: string
}

/**
 * Request parameters for disableLocation operation in LocationsApi.
 * @export
 * @interface LocationsApiDisableLocationRequest
 */
export interface LocationsApiDisableLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiDisableLocation
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof LocationsApiDisableLocation
     */
    readonly reActive?: boolean
}

/**
 * Request parameters for editLocation operation in LocationsApi.
 * @export
 * @interface LocationsApiEditLocationRequest
 */
export interface LocationsApiEditLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiEditLocation
     */
    readonly id: string

    /**
     * 
     * @type {PutLocationRequest}
     * @memberof LocationsApiEditLocation
     */
    readonly putLocationRequest: PutLocationRequest
}

/**
 * Request parameters for enableLocation operation in LocationsApi.
 * @export
 * @interface LocationsApiEnableLocationRequest
 */
export interface LocationsApiEnableLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiEnableLocation
     */
    readonly id: string
}

/**
 * Request parameters for getControllersByLocationId operation in LocationsApi.
 * @export
 * @interface LocationsApiGetControllersByLocationIdRequest
 */
export interface LocationsApiGetControllersByLocationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetControllersByLocationId
     */
    readonly id: string
}

/**
 * Request parameters for getDetailLocationDatabase operation in LocationsApi.
 * @export
 * @interface LocationsApiGetDetailLocationDatabaseRequest
 */
export interface LocationsApiGetDetailLocationDatabaseRequest {
    /**
     * 
     * @type {GetLocationDatabaseDetailRequest}
     * @memberof LocationsApiGetDetailLocationDatabase
     */
    readonly getLocationDatabaseDetailRequest: GetLocationDatabaseDetailRequest
}

/**
 * Request parameters for getLocationById operation in LocationsApi.
 * @export
 * @interface LocationsApiGetLocationByIdRequest
 */
export interface LocationsApiGetLocationByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetLocationById
     */
    readonly id: string
}

/**
 * Request parameters for getLocationsActiveWithCustomer operation in LocationsApi.
 * @export
 * @interface LocationsApiGetLocationsActiveWithCustomerRequest
 */
export interface LocationsApiGetLocationsActiveWithCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetLocationsActiveWithCustomer
     */
    readonly customerId: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetLocationsActiveWithCustomer
     */
    readonly status: string
}

/**
 * Request parameters for getLocationsPaging operation in LocationsApi.
 * @export
 * @interface LocationsApiGetLocationsPagingRequest
 */
export interface LocationsApiGetLocationsPagingRequest {
    /**
     * 
     * @type {number}
     * @memberof LocationsApiGetLocationsPaging
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetLocationsPaging
     */
    readonly keySearch: string

    /**
     * 
     * @type {number}
     * @memberof LocationsApiGetLocationsPaging
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetLocationsPaging
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetLocationsPaging
     */
    readonly orderDesc: string
}

/**
 * Request parameters for getLocationsWithCustomer operation in LocationsApi.
 * @export
 * @interface LocationsApiGetLocationsWithCustomerRequest
 */
export interface LocationsApiGetLocationsWithCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetLocationsWithCustomer
     */
    readonly customerId: string
}

/**
 * Request parameters for getUnitsByLocationId operation in LocationsApi.
 * @export
 * @interface LocationsApiGetUnitsByLocationIdRequest
 */
export interface LocationsApiGetUnitsByLocationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiGetUnitsByLocationId
     */
    readonly id: string
}

/**
 * Request parameters for postCreateLocation operation in LocationsApi.
 * @export
 * @interface LocationsApiPostCreateLocationRequest
 */
export interface LocationsApiPostCreateLocationRequest {
    /**
     * 
     * @type {PostLocationRequest}
     * @memberof LocationsApiPostCreateLocation
     */
    readonly postLocationRequest: PostLocationRequest
}

/**
 * Request parameters for searchActiveLocations operation in LocationsApi.
 * @export
 * @interface LocationsApiSearchActiveLocationsRequest
 */
export interface LocationsApiSearchActiveLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationsApiSearchActiveLocations
     */
    readonly keySearch: string
}

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @param {LocationsApiCheckExistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public checkExist(requestParameters: LocationsApiCheckExistRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).checkExist(requestParameters.postLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiCheckLocationByLocationNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public checkLocationByLocationNumber(requestParameters: LocationsApiCheckLocationByLocationNumberRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).checkLocationByLocationNumber(requestParameters.loationNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiDisableLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public disableLocation(requestParameters: LocationsApiDisableLocationRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).disableLocation(requestParameters.id, requestParameters.reActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiEditLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public editLocation(requestParameters: LocationsApiEditLocationRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).editLocation(requestParameters.id, requestParameters.putLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiEnableLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public enableLocation(requestParameters: LocationsApiEnableLocationRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).enableLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getActiveLocations(options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getActiveLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiGetControllersByLocationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getControllersByLocationId(requestParameters: LocationsApiGetControllersByLocationIdRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getControllersByLocationId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiGetDetailLocationDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getDetailLocationDatabase(requestParameters: LocationsApiGetDetailLocationDatabaseRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getDetailLocationDatabase(requestParameters.getLocationDatabaseDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiGetLocationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationById(requestParameters: LocationsApiGetLocationByIdRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocations(options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiGetLocationsActiveWithCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationsActiveWithCustomer(requestParameters: LocationsApiGetLocationsActiveWithCustomerRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationsActiveWithCustomer(requestParameters.customerId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiGetLocationsPagingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationsPaging(requestParameters: LocationsApiGetLocationsPagingRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationsPaging(requestParameters.limit, requestParameters.keySearch, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiGetLocationsWithCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationsWithCustomer(requestParameters: LocationsApiGetLocationsWithCustomerRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationsWithCustomer(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getTotalLocation(options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getTotalLocation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiGetUnitsByLocationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getUnitsByLocationId(requestParameters: LocationsApiGetUnitsByLocationIdRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getUnitsByLocationId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiPostCreateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public postCreateLocation(requestParameters: LocationsApiPostCreateLocationRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).postCreateLocation(requestParameters.postLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LocationsApiSearchActiveLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public searchActiveLocations(requestParameters: LocationsApiSearchActiveLocationsRequest, options?: AxiosRequestConfig) {
        return LocationsApiFp(this.configuration).searchActiveLocations(requestParameters.keySearch, options).then((request) => request(this.axios, this.basePath));
    }
}
